import script from "./MaterialSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialSelector.vue?vue&type=script&setup=true&lang=ts"

import "./MaterialSelector.vue?vue&type=style&index=0&id=676a897e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676a897e"]])

export default __exports__